import { render, staticRenderFns } from "./NewPaymentPassword.vue?vue&type=template&id=95496302&scoped=true"
import script from "./NewPaymentPassword.vue?vue&type=script&lang=js"
export * from "./NewPaymentPassword.vue?vue&type=script&lang=js"
import style0 from "./NewPaymentPassword.vue?vue&type=style&index=0&id=95496302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95496302",
  null
  
)

export default component.exports